//=====================================================
//　予約情報
//=====================================================

import { useContext } from "react";
import { formatDate, formatString } from "../utils/CommonFunc";
import { ReservationType } from "../utils/ConstCommon";
import { CtxClinicSystemInfo, CtxNewReservation, CtxClinicInfo } from "../utils/Contexts";

export function ReservationInfo(){

    const cnr = useContext(CtxNewReservation);
    const ccsi = useContext(CtxClinicSystemInfo);
    const cci = useContext(CtxClinicInfo);

    //予約確認画面と完了画面の場合は表示する項目を変更
    const path = window.location.pathname;
    let fullView = false;
    if (path.indexOf("reservation/confirm") > 0 || path.indexOf("reservation/complete") > 0){
        fullView = true;
    }

    return (
        <dl className="info_list info_list-reserve">
            {(cnr.data.date && !cnr.data.beforeDate) &&
                <>
                    <dt>ご予約日時</dt>
                    <dd className="info_list-reserve-datetime">{formatDate(cnr.data.date, true)}</dd>
                </>
            }
            {(cnr.data.beforeDate) &&
                <>
                    <dt>ご予約日時</dt>
                    <dd className="info_list-reserve-datetime">
                        <div className="info_list-reserve-datetime-content">
                            <span className="tag tag-gray">変更前</span><span className="reserve-datetime-before">{formatDate(formatString(cnr.data.beforeDate), true)}</span>
                        </div>
                        {cnr.data.date && 
                            <div className="info_list-reserve-datetime-content">
                                <span className="tag tag-blue">変更後</span><span className="reserve-datetime-after">{formatDate(cnr.data.date, true)}</span>
                            </div>
                        }
                    </dd>
                </>
            }
            {( cnr.data.menu && 
             ( ccsi.data.display.medicalType || cnr.type === ReservationType.First || cnr.type === ReservationType.ReFirst ) ) &&
                <>
                    <dt>治療メニュー</dt>
                    <dd className="info_list-reserve-menu">
                        {cnr.data.menu}
                        {(ccsi.data.display.medicalCareTime && cnr.data.menutime !== undefined) && 
                            <p className="treatment_time text-s">診療時間：{cnr.data.menutime}分</p>
                        }
                    </dd>
                </>
            }
            {cnr.data.doctor && ccsi.data.display.doctor &&
                <>
                    <dt>担当医</dt>
                    <dd className="info_list-reserve-doctor">{cnr.data.doctor}</dd>
                </>
            }
            {(fullView && cnr.data.name) && 
                <>
                    <dt>お名前</dt>
                    <dd className="info_list-reserve-name">{cnr.data.name}</dd>
                </>
            }
            {(fullView && cnr.data.telPrivate) && 
                <>
                    <dt>携帯電話番号</dt>
                    <dd className="info_list-reserve-phone-number">{cnr.data.telPrivate}</dd>
                </>
            }            
            {(fullView && cnr.data.tel) && 
                <>
                    <dt>固定電話番号</dt>
                    <dd className="info_list-reserve-phone-number">{cnr.data.tel}</dd>
                </>
            }
            {(fullView && cnr.data.email) && 
                <>
                    <dt>E-mail</dt>
                    <dd className="info_list-reserve-mail">{cnr.data.email}</dd>
                </>
            }
            {fullView && cnr.data.birthday && ccsi.data.display.birthday &&
                <>
                    <dt>生年月日</dt>
                    <dd className="info_list-reserve-birth">{cnr.data.birthday}</dd>
                </>
            }
            {(fullView && cnr.data.symptoms) && 
                <>
                    <dt>{cci.data.symptomsTitle}</dt>
                    <dd className="info_list-reserve-symptoms">{cnr.data.symptoms}</dd>
                </>
            }
        </dl>
    )

}